import { useState, useEffect } from "react";
import api from "../../axiosconfig";

const emptyScores = {
    physical: null, emotional: null, acceptance: null, relationships: null,
    loving_kindness: null, intellectual: null,
};
const empty = { scores: emptyScores, filteredCount: 0, totalCount: 0, error: "" };

function stripFilters(url) {
    const parsed = new URL(url, window.location.origin);
    ["age", "gender", "location", "description", "job_title", "company", "interest"]
        .forEach((key) => parsed.searchParams.delete(key));
    return parsed.pathname + "?" + parsed.searchParams.toString();
}

export default function usePearliScores(viewMode, url) {
    const [state, setState] = useState({ ...empty, key: null, loading: true });

    useEffect(() => {
        if (viewMode !== "current") return undefined;
        let active = true;
        setState({ ...empty, key: url, loading: true });

        async function fetchScores() {
            try {
                const unfilteredUrl = stripFilters(url);
                // A single request supplies both counts when no demographic filters are set.
                const filteredRequest = api.get(url);
                const [res, totalRes] = await Promise.all([
                    filteredRequest,
                    unfilteredUrl === url ? filteredRequest : api.get(unfilteredUrl),
                ]);
                const data = res?.data?.data;
                const d = data?.scores;
                if (active) setState({
                    key: url, loading: false, error: "",
                    filteredCount: data?.count ?? 0,
                    totalCount: totalRes?.data?.data?.count ?? 0,
                    scores: {
                        physical: d?.AvgP ?? null, emotional: d?.AvgE ?? null,
                        acceptance: d?.AvgA ?? null, relationships: d?.AvgR ?? null,
                        loving_kindness: d?.AvgL ?? null, intellectual: d?.AvgI ?? null,
                    },
                });
            } catch {
                if (active) setState({ ...empty, key: url, loading: false,
                    error: "Assessment data could not be loaded. Please try again." });
            }
        }
        fetchScores();
        return () => { active = false; };
    }, [viewMode, url]);

    // Hide the previous cohort immediately, before the new request's effect runs.
    const current = viewMode === "current" && state.key === url;
    const result = current ? state : { ...empty, loading: viewMode === "current" };
    const hasData = !result.loading && !result.error && result.filteredCount > 0
        && Object.values(result.scores).every(Number.isFinite);
    return { ...result, hasData };
}
